import { Seo } from '@/components/Seo';
import { JsonLd, makeBreadcrumbSchema } from '@/components/Schema';

export function Terms() {
  return (
    <>
      <Seo
        title="Terms of Service | ai-free-resume"
        description="ai-free-resume terms of service. Free resume builder with optional Pro subscription. No refunds after download."
        path="/terms"
        noindex
      />
      <JsonLd schema={makeBreadcrumbSchema([{ name: 'Terms of Service', path: '/terms' }])} />

      <section className="bg-[#F6F9FC] py-16 md:py-24">
        <div className="mx-auto max-w-[800px] px-6">
          <div className="rounded-2xl bg-white p-8 md:p-12 shadow-sm">
            <h1 className="text-3xl font-bold text-[#0A2540] md:text-4xl">Terms of Service</h1>
            <p className="mt-4 text-sm text-[#718096]">Last updated: July 19, 2026</p>

            <h2 className="mt-8 text-xl font-semibold text-[#0A2540]">1. Acceptance of Terms</h2>
            <p className="mt-2 text-[#4A5568]">
              By using ai-free-resume.org, you agree to these terms. If you do not agree, please do not use the service.
            </p>

            <h2 className="mt-8 text-xl font-semibold text-[#0A2540]">2. Free and Paid Services</h2>
            <p className="mt-2 text-[#4A5568]">
              The core resume builder is free. Optional Pro and Lifetime subscriptions provide additional AI rewrites and templates. Prices are subject to change with notice.
            </p>

            <h2 className="mt-8 text-xl font-semibold text-[#0A2540]">3. No Refunds</h2>
            <p className="mt-2 text-[#4A5568]">
              All payments are final. Due to the digital nature of the service, we do not offer refunds once a download or subscription has been used.
            </p>

            <h2 className="mt-8 text-xl font-semibold text-[#0A2540]">4. User Content</h2>
            <p className="mt-2 text-[#4A5568]">
              You retain ownership of your resume content. We do not claim any rights over the information you enter.
            </p>

            <h2 className="mt-8 text-xl font-semibold text-[#0A2540]">5. Limitation of Liability</h2>
            <p className="mt-2 text-[#4A5568]">
              ai-free-resume is provided as-is. We are not responsible for any job application outcomes, hiring decisions, or damages resulting from use of the service.
            </p>

            <h2 className="mt-8 text-xl font-semibold text-[#0A2540]">6. Contact</h2>
            <p className="mt-2 text-[#4A5568]">
              For legal questions, contact us at support@ai-free-resume.org.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default Terms;
